module.exports = __webpack_public_path__ + "img/266.product_show.3e418e50.svg";